






























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from "@/definitions";

import { Design } from "@/model/document2/page/surface/design/design";
import { PlainTextLayer } from "@/model/document2/page/surface/design/layer/plainTextLayer";
import { SimpleTextLayer } from '@/model/document2/page/surface/design/layer/simpleTextLayer';
import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import { TextInfo } from '@/utilityModels/textInfo';
import { MathHelper } from '@/helper/mathHelper';
import { FontManager } from '@/model/fontManager/fontManager';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";
import AlignLeftOn from "../resources/alignLeft_on.vue";
import AlignLeftOff from "../resources/alignLeft_off.vue";
import AlignCenterOn from "../resources/alignCenter_on.vue";
import AlignCenterOff from "../resources/alignCenter_off.vue";
import AlignRightOn from "../resources/alignRight_on.vue";
import AlignRightOff from "../resources/alignRight_off.vue";
import AlignEvenOn from "../resources/alignEven_on.vue";
import AlignEvenOff from "../resources/alignEven_off.vue";
import AlignTopOn from "../resources/alignTop_on.vue";
import AlignTopOff from "../resources/alignTop_off.vue";
import AlignMiddleOn from "../resources/alignMiddle_on.vue";
import AlignMiddleOff from "../resources/alignMiddle_off.vue";
import AlignBottomOn from "../resources/alignBottom_on.vue";
import AlignBottomOff from "../resources/alignBottom_off.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    DropdownList,
    ColorSelector,
    FontSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
    AlignLeftOn,
    AlignLeftOff,
    AlignCenterOn,
    AlignCenterOff,
    AlignRightOn,
    AlignRightOff,
    AlignEvenOn,
    AlignEvenOff,
    AlignTopOn,
    AlignTopOff,
    AlignMiddleOn,
    AlignMiddleOff,
    AlignBottomOn,
    AlignBottomOff
  }
})

// 選択テキストレイヤーすべての有効
export default class MultipleTextStyle extends Vue 
{
    @Prop() private design!: Design;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onFocusInput()
    {
        this.changeInputMode(1);
    }

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    // すべてのレイヤーの特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getLayerProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof PlainTextLayer)
            {
                var val = layer[property];
                if(val != null)
                {
                    if(value == null) { value = val; }
                    else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                    else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                    else if(value === val) { value = val; }
                    else 
                    { 
                        isBreak = true; 
                        break;
                    }
                }
            }
            else if(layer instanceof SimpleTextLayer)
            {
                var targetValue = layer[property];
                if(targetValue != null)
                {
                    if(value == null) { value = targetValue; }
                    else if(typeof(value) == "number" && typeof(targetValue) == "number" && MathHelper.equals(value, targetValue)) value = targetValue;
                    else if(value instanceof ColorConstruct && targetValue instanceof ColorConstruct && value.equals(targetValue)) value = targetValue;
                    else if(value === targetValue) value = targetValue;
                    else 
                    { 
                        isBreak = true; 
                        break;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    // すべてのレイヤーのすべての文字の文法情報の特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof PlainTextLayer)
            {
                var infoArray = layer.textInfoArray;
                for(var j = 0; j < infoArray.length; ++j)
                {
                    var info = infoArray[j];
                    var val = info[property];
                    if(val != null)
                    {
                        if(value == null) { value = val; }
                        else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                        else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                        else if(value === val) { value = val; }
                        else 
                        { 
                            isBreak = true; 
                            break;
                        }
                    }

                    if(isBreak) { break; }
                }
            }
            else if(layer instanceof SimpleTextLayer)
            {
                var baseTextInfo = layer.baseTextInfo;
                var targetValue = baseTextInfo[property];
                if(targetValue != null)
                {
                    if(value == null) value = targetValue;
                    else if(typeof(value) == "number" && typeof(targetValue) == "number" && MathHelper.equals(value, targetValue)) value = targetValue;
                    else if(value instanceof ColorConstruct && targetValue instanceof ColorConstruct && value.equals(targetValue)) value = targetValue;
                    else if(value == targetValue) value = targetValue;
                    else
                    {
                        isBreak = true;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private getFontManager() : FontManager
    {
        return this.$store.getters.fontManager;
    }
    private get selectedFontId() { return this.getCurrentFontId(); }
    private getCurrentFontId() : string | null
    {
        var fontId = this.getProperty("fontId");
        return fontId != null && typeof(fontId) == "string" ? fontId : null;
    }
    private onSelectFont(fontId: string)
    {
        this.changeTextInfo(fontId, "fontId", true, true);
    }

    private get textColor() : ColorConstruct | null
    {
        var textColor =  this.getProperty("textColor");
        return textColor != null && textColor instanceof ColorConstruct ? textColor : new ColorConstruct();
    }
    private get textColorStyle() 
    { 
        var textColor =  this.getProperty("textColor");
        return textColor == null ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : textColor.hex }; 
    }

    private get lineSpacing() 
    { 
        var lineSpacing = this.getLayerProperty("lineSpacing");
        return lineSpacing != null && typeof(lineSpacing) == "number" ? lineSpacing : 100;
    }

    private get isLineSpacingBlank() 
    { 
        var lineSpacing = this.getLayerProperty("lineSpacing");
        return !(lineSpacing != null && typeof(lineSpacing) == "number");
    }

    private isHorizontalAlignment(type)
    {
        var value = this.getLayerProperty("horizontalAlignment");
        if (!(value != null && typeof(value) == "number")) { value = 0; }

        var result = false;
        if(type == "left")
        { 
            result = value == 0;
        }
        else if(type == "center")
        {
            result = value == 1;
        }
        else if(type == "right")
        {
            result = value == 2;
        }
        else if(type == "even")
        {
            result = value == 3;
        }
        return result;
    }

    private isVerticalAlignment(type)
    {
        var value = this.getLayerProperty("verticalAlignment");
        if (!(value != null && typeof(value) == "number")) { value = 0; }

        var result = false;
        if(type == "top")
        { 
            result = value == 0;
        }
        else if(type == "center")
        {
            result = value == 1;
        }
        else if(type == "bottom")
        {
            result = value == 2;
        }
        return result;
    }

    private get isTextOrientationVertical() 
    { 
        var value = this.getLayerProperty("textOrientation");
        if (!(value != null && typeof(value) == "number")) { value = 0; }

        return value == 1; 
    }
    private setTextOrientation(orientation)
    {
        // 文字方向切り替え
        var value = orientation == "vertical" ? 1 : 0;
        this.changeLayerProperty(value, "textOrientation", true, true);
    }

    private getPropertyValue(property : string)
    {
        var def = 0;
        if(property == "fontSize") { def = 14; }
        else if(property == "letterSpacing") { def = 0; }
        else if(property == "letterWidth") { def = 100; }

        var value = this.getProperty(property);
        return value != null && typeof(value) == "number" ? value : def;
    }

    private getPropertyBlank(property : string)
    {
        var value = this.getProperty(property);
        return !(value != null && typeof(value) == "number");
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //TODO Props
    openStatus = {
        opend: true
    };

    multipleTextTransformContentsOpenAnimate = false;
    multipleTextTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.multipleTextTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.multipleTextTransformContentsCloseAnimate = false;
            this.multipleTextTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.multipleTextTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.multipleTextTransformContentsOpenAnimate = false;
        }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓チェックボックスのアニメーション↓↓↓↓↓
    private get autoSize() 
    {
        var value = this.getLayerProperty("autoSize");
        if (!(value != null && typeof(value) == "boolean")) { value = false; }

        return value;
    }
    private autoSizeChange() 
    {
        var newValue = !(this.autoSize);
        this.changeLayerProperty(newValue, "autoSize", true, true);
    }

    private get autoNewLine() 
    {
        var value = this.getLayerProperty("autoNewLine");
        if (!(value != null && typeof(value) == "boolean")) { value = false; }

        return value;
    }

    private autoNewLineChange() 
    {
        var newValue = !(this.autoNewLine);
        this.changeLayerProperty(newValue, "autoNewLine", true, true);
    }

    private get bold()
    {
        var value = this.getProperty("bold");
        if (!(value != null && typeof(value) == "boolean")) { value = false; }

        return value;
    }
    
    private boldChange()
    {
        this.changeTextInfo(!this.bold, "bold", true);
    }

    private get italic()
    {
        var value = this.getProperty("italic");
        if (!(value != null && typeof(value) == "boolean")) { value = false; }

        return value;
    }

    private italicChange()
    {
        this.changeTextInfo(!this.italic, "italic", true);
    }

    private get underline()
    {
        var value = this.getProperty("underline");
        if (!(value != null && typeof(value) == "boolean")) { value = false; }

        return value;
    }

    private underlineChange()
    {
        this.changeTextInfo(!this.underline, "underline", true);
    }

    //↑↑↑↑↑チェックボックスのアニメーション↑↑↑↑↑

    // カラーピッカー表示非表示
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }

    // 色変更中
    private onChangingColor(color)
    {
        this.changeTextInfo(color, "textColor", false);
    }
    
    // 色変更完了
    private onChangedColor(color)
    {
        this.changeTextInfo(color, "textColor", true);
    }

    // controller
    private setHorizontalAlignment(type)
    {
        var value = this.getLayerProperty("horizontalAlignment");
        if (!(value != null && typeof(value) == "number")) { value = -1; }
        var newValue = value;

        if(type == "left") { newValue = 0; }
        else if(type == "center") { newValue = 1; }
        else if(type == "right") { newValue = 2; }
        else if(type == "even") { newValue = 3; }

        if(newValue != value)
        {
            this.changeLayerProperty(newValue, "horizontalAlignment", true, true);
        }
    }

    private setVerticalAlignment(type)
    {
        var value = this.getLayerProperty("verticalAlignment");
        if (!(value != null && typeof(value) == "number")) { value = -1; }
        var newValue = value;

        if(type == "top") { newValue = 0; }
        else if(type == "center") { newValue = 1; }
        else if(type == "bottom") { newValue = 2; }

        if(newValue != value)
        {
            this.changeLayerProperty(newValue, "verticalAlignment", true, true);
        }
    }

    // ValueEdit
    // テキスト固有の値変更
    private onChangingTextValue(value : number, tag : string)
    {
        this.changeTextInfo(value, tag, false);
    }

    private onChangedTextValue(value : number, tag : string)
    {
        this.changeTextInfo(value, tag, true);
    }

    // レイヤー全体の値変更
    private onChangingLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedLayerValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private changeTextInfo(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            if(layer.layerType == "plainText")
            {
                this.$emit("doCommand", "changePlainTextLayerWholeTextInfo", {
                    layer : layer,
                    propertyName : propertyName,
                    value : value,
                    isFinish : (isFinish || isOnce) && i == layers.length - 1,
                    isOnce : false
                });
            }
            else if(layer.layerType == "simpleText")
            {
                this.$emit("doCommand", "changeSimpleTextLayerTextInfo", {
                    layer : layer,
                    propertyName : propertyName,
                    value : value,
                    isFinish : (isFinish || isOnce) && i == layers.length - 1,
                    isOnce : false
                });
            }
        }
    }


    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false) 
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            this.$emit("doCommand", "changeLayerProperty", {
                layer : layer,
                propertyName : propertyName,
                value : value,
                isFinish : (isFinish || isOnce) && i == layers.length - 1,
                isOnce : false
            });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
    
    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
